<app-mobile-menu #mobileMenu [navigationItems]="navigationItems$ | async"></app-mobile-menu>
<div class="h-100 s7-main-container" [ngClass]="{ 'is-cypress': isCypress }">
    <div class="d-flex flex-column mask-wrapper h-100">
        <div class="mask-page" [class.hidden]="(showSpinner$ | async) === false">
            <div class="spinner-pusher-page">
                <div class="s7-spinner">
                    <div class="spinner-tail spinner-tail-gray"></div>
                </div>
            </div>
        </div>
        <div class="menu-mobile-backdrop" (click)="mobileMenu.closeMobileMenu()"></div>
        <header *ngIf="displayHeader$ | async" class="header" [class.header-anonymous]="!isAuthorized">
            <app-header [navigationItems]="navigationItems$ | async"></app-header>
        </header>
        <main class="layout" [ngClass]="{ 'layout-dark': renderDarkLayout$ | async }" [class.CCR01-anonymous]="CCR01RedesignEnabled$ | async">
            <router-outlet></router-outlet>
        </main>
        <app-footer></app-footer>
    </div>
</div>
